import * as a from "react";
import t from "../lib/IconBase.es.js";
import f from "../defs/SquareHalf.es.js";
const e = a.forwardRef((o, r) => /* @__PURE__ */ a.createElement(t, { ref: r, ...o, weights: f }));
e.displayName = "SquareHalfIcon";
const s = e;
export {
  s as SquareHalf,
  e as SquareHalfIcon
};
